import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { Icons } from "../../../data/Assets";

import { SVGIcon } from "../../wrappers/SVGIcon";
import { TextArea, TextInput } from "../../reusables/FormElements";

import { IAssessmentDetails } from "../../../interfaces/services";

import { useInviteWorkerFromAssessment } from "../../../hooks/assessments";
interface IAssessmentInviteWorkerProps {
    assessmentData: IAssessmentDetails | null;
    resetMainView: () => void;
};
export const AssessmentInviteWorker = (props: IAssessmentInviteWorkerProps) => {
    const { assessmentData, resetMainView } = props;

    const navigate = useNavigate();

    const [workerNameFromAssessment, setWorkerNameFromAssessment] = useState<string>('');
    const [workerName, setWorkerName] = useState<string>('');
    const [personalEmail, setPersonalEmail] = useState<string>('');
    const [message, setMessage] = useState<string>('');
    const [isInviting, setIsInviting] = useState<boolean>(false);
    const [invitationSuccess, setInvitationSuccess] = useState<boolean>(false);

    const { mutate: inviteWorkerFromAssessment } = useInviteWorkerFromAssessment();

    useEffect(() => {
        if (assessmentData) {
            let oWorkerName = '';
            if (assessmentData.foreign_worker?.worker_details[0].first_name && assessmentData.foreign_worker?.worker_details[0].last_name) {
                oWorkerName = `${assessmentData.foreign_worker?.worker_details[0].first_name} ${assessmentData.foreign_worker?.worker_details[0].last_name}`;
            } else if (assessmentData.worker_name) {
                oWorkerName = assessmentData.worker_name;
            }
            setWorkerName(oWorkerName);
            setWorkerNameFromAssessment(oWorkerName);

            let oPersonalEmail = '';
            if (assessmentData.foreign_worker?.worker_details[0].email) {
                oPersonalEmail = assessmentData.foreign_worker?.worker_details[0].email;
            } else if (assessmentData.resume_summary) {
                const emailMatch = RegExp(/\*\*Personal-Email:\s*([^\s*]+@[^\s*]+)\*\*/).exec(assessmentData.resume_summary);
                oPersonalEmail = emailMatch ? emailMatch[1] : '';
            }
            setPersonalEmail(oPersonalEmail);
        };
    }, [assessmentData]);

    const onSkip = () => {
        if (!assessmentData?.id || isInviting) return;

        resetMainView();
        navigate(`/assessments/${assessmentData.id}/immigration-recommendations`);
    };

    const isInviteDisabled = () => {
        return !assessmentData?.id || !workerName?.length || !personalEmail?.length || isInviting;
    };

    const onInvite = () => {
        if (isInviteDisabled() || !assessmentData) return;

        inviteWorkerFromAssessment({
            payload: {
                assessment_id: assessmentData.id,
                worker_name: workerName,
                personal_email: personalEmail,
                message: message,
                location_id: assessmentData.location_id,
                job_title: assessmentData.title,
                noc_code: assessmentData.noc,
                job_type: assessmentData.full_time ? 'full-time' : 'part-time',
                wage: assessmentData.wage_max,
                wage_type: assessmentData.wage_type,
            },
            setIsInviting,
            setInvitationSuccess,
        })
    };

    return (
        <div className="immployer__assessment__invite_worker__view">
            <div className="immployer__assessment__invite_worker__left">
                <div className="immployer__assessment__invite_worker__note">
                    <SVGIcon src={Icons.StarCircleFill} color="primary" />
                    <p>For the most optimal assessment invite {workerName} to complete Immproved.</p>
                </div>
                <div className='immployer__assessment__invite_worker__form'>
                    <div className='immployer__assessment__invite_worker__form__group'>
                        <TextInput
                            required={true}
                            name="name"
                            type="text"
                            max_length={100}
                            label="Name of the Worker"
                            placeholder="Enter worker name"
                            value={workerName}
                            read_only={!!workerNameFromAssessment?.length}
                            onChange={(value: string) => {
                                if (!workerNameFromAssessment?.length) {
                                    setWorkerName(value);
                                };
                            }}
                        />
                        <TextInput
                            required={true}
                            name="email"
                            type="text"
                            max_length={100}
                            label="Personal Email"
                            placeholder="Enter worker email"
                            onChange={(value: string) => setPersonalEmail(value)}
                            value={personalEmail}
                            read_only={invitationSuccess}
                        />
                    </div>
                    <TextArea
                        name="message"
                        label="Message"
                        placeholder="Enter message"
                        rows={5}
                        onChange={(value: string) => setMessage(value)}
                        value={message}
                    />
                </div>
                <div className="immployer__assessment__invite_worker__actions">
                    {invitationSuccess
                        ? <button
                            className="immployer__btn immployer__btn__primary"
                            onClick={onSkip}
                        >
                            Continue to Recommendations
                        </button>
                        : <>
                            <button
                                className={`immployer__btn immployer__btn__primary ${isInviteDisabled() ? 'immployer__btn__primary__disabled' : ''}`}
                                onClick={onInvite}
                            >
                                {isInviting ? 'Inviting...' : 'Invite'}
                            </button>
                            <button
                                className={`immployer__btn immployer__btn__secondary`}
                                onClick={onSkip}
                            >
                                Skip
                            </button>
                        </>
                    }
                </div>
            </div>
            <div className="immployer__assessment__invite_worker__right">
                <div className="immployer__assessment__invite_worker__video_box">
                    <div className="immployer__assessment__invite_worker__video_title">
                        Why invite {workerName} to complete Immproved?
                    </div>
                    <div className="immployer__assessment__invite_worker__video_description">
                        It would be a great idea to send {workerName} an email so they pay special attention. We will ask {workerName} to complete this information with 1-day.
                    </div>
                    {/* <div className="immployer__assessment__invite_worker__video_container">
                        <SVGIcon src={Icons.PlayCircle} color="primary" hoverColor="primary" />
                    </div> */}
                </div>
                <div className="immployer__assessment__invite_worker__tip_box">
                    <div className="immployer__assessment__invite_worker__tip_title">
                        TIP: Send an email to ensure action!
                    </div>
                    <div className="immployer__assessment__invite_worker__tip_description">
                        We made it easy for you- simply click copy, review the email and send it off!
                    </div>
                    <button className="immployer__btn immployer__btn__primary immployer__btn__primary__disabled">
                        Copy
                    </button>
                </div>
            </div>
        </div>
    );
};